import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { ListReceipts } from "../../../domain/usecases/list-receipts";
import { Receipt } from "../../../domain/models/receipt-model";
import { Provider } from "react-redux";
import { store } from "./store";
import Navbar from "../components/navbar";

type Props = {
  listReceipts: ListReceipts;
};

export const Receipts: React.FC<Props> = ({ listReceipts }) => {
  const [receipts, setReceipts] = useState<Receipt[]>([]);

  return (
    <>
      <Navbar title="Entradas" />
      <Provider store={store}>
        <Outlet />
      </Provider>
    </>
  );
};
